import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CreatePasswordForm from './components/CreatePasswordForm/CreatePasswordForm';
import { endTitlePage } from '../../../services/config';
import './CreatePasswordPage.scss';

const CreatePasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const headInfos = {
        title: 'Création de mot de passe' + endTitlePage,
        description: 'Créé ton mot de passe pour accéder à tes formations'
    };

    return (
        <div className="create-password-page">
            <Helmet>
                <title>{headInfos.title}</title>
                <meta name="description" content={headInfos.description} />
            </Helmet>
            <div className="logo_container">
                <img src={'/assets/logo_transparent.png'} alt="logo" className="logo" loading="lazy" />
            </div>
            <CreatePasswordForm 
                createToken={token} 
                onSuccess={() => navigate('/connexion')} 
            />
        </div>
    );
};

export default CreatePasswordPage;